import routesConfig from 'src/routes.config'
import variables from 'src/styles/variables'
import { withPrefix } from 'gatsby'

export default {
  ArPartners: {
    title: 'Our products are used and trusted by',
    logos: [
      {
        alt: 'AXIS logo',
        url: withPrefix('img/ArPartners4.svg'),
      },
      {
        alt: 'CHAUCER logo',
        url: withPrefix('img/ArPartners6.svg'),
      },
      {
        alt: 'Convex logo',
        url: withPrefix('img/ArPartners7.svg'),
      },
      {
        alt: 'AON logo',
        url: withPrefix('img/ArPartners1.svg'),
      },
      {
        alt: 'CAPITA logo',
        url: withPrefix('img/ArPartners3.svg'),
      },
    ],
  },
  ArTestimonials: [
    {
      image: {
        alt: 'Aon Affinity logo',
        url: withPrefix('img/ArPartners1.svg'),
      },
      description: '“Artificial are a fundamental part of our proposition and are a key differentiating factor when compared to competition.”',
      name: 'Gonzalo Torres De Arcos',
      position: 'Global Leader - Telecom Practice, Aon Affinity',
    },
    {
      image: {
        alt: 'Capita Plc logo',
        url: withPrefix('img/ArPartners3.svg'),
      },
      description: '“Artificial’s technology is truly unique in the market. They genuinely have the ability to disrupt at scale.”',
      name: 'Dave Richards',
      position: 'Technical Director, Capita Plc',
    },
  ],
  ArCTASection: {
    title: 'Want to learn more?',
    cta: {
      label: 'Contact Us',
      url: routesConfig.contact(),
    },
    backgroundColor: variables.colors.asfalt,
  },
}
